import { render, staticRenderFns } from "./WorkShift.vue?vue&type=template&id=cce26c18&"
import script from "./WorkShift.vue?vue&type=script&lang=js&"
export * from "./WorkShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QItemLabel}, component.options.components || {})
